export const isLocalhost = typeof window !== "undefined" && window.location.hostname === "localhost";
